/*
 * Used when completing Ecommerce Booking/Order
 */
export enum CompleteResponse {
  Success = 1,     // Success completing
  Error = 2,       // Error completing
  Redirect = 3,    // 3ds payment validation required before completing
  VerificationRequired = 4 // Email verification required before completing
}
